import ApiService from "./ApiService";
import { axiosInstance } from "./axiosInstance";
import appConfig from "configs/app.config";

const baseURL = `${appConfig.baseUrl}`;

export async function apiSignUp(data) {
  return axiosInstance.post(`${baseURL}auth/signup`, data);
}

export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: "/auth/login",
    method: "post",
    data,
  });
}
// export async function apiSignIn(data) {
//     return axiosInstance.post(
//       `${baseURL}/auth/login`,data
//     );
//   }
// export async function apiSignUp(data) {
//     return ApiService.fetchData({
//         url: "/auth/signup",
//         method: "post",
//         data,
//     });
// }

export async function apiSignOut(data) {
  return ApiService.fetchData({
    url: "/sign-out",
    method: "post",
    data,
  });
}

export async function apiForgotPassword(data) {
  return ApiService.fetchData({
    url: `/auth/forgotPassword?email=${data.email}`,
    method: "get",
  });
}

export async function apiValidateResetToken(data) {
  return ApiService.fetchData({
    url: `/auth/verifyToken?token=${data.token}&email=${data.email}`,
    method: "get",
  });
}

export async function apiResetPassword(data) {
  return ApiService.fetchData({
    url: "/auth/resetPasswordToken",
    method: "post",
    data,
  });
}

// Manually added for change password
// export async function apiChangePassword(data) {
//     return axiosInstance.post(
//         `${baseURL}/auth/resetPassword`,
//         data
//     );
// }
export async function apiChangePassword(data) {
  return ApiService.fetchData({
    url: `${baseURL}auth/resetPassword`,
    method: "post",
    data,
  });
}
